import { Component } from '@angular/core';

@Component({
    selector:'big-title',
    template:"<span style='display:block;font-size:30px;padding:20px 0px;'>Registration</span>",
})

export class TitleComponent {

}


// WEBPACK FOOTER //
// ./src/app/text-title-component.ts